$(".filter-btn").click(function() {
    $(".feedback-overlay").addClass("feedback-active")
    $(".wrapper__inner--alt").addClass("feedback-active")
    $(".btn-phone").addClass("d-none")
})

$(".feedback-cancel").click(function() {
    $(".feedback-overlay").removeClass("feedback-active")
    $(".wrapper__inner--alt").removeClass("feedback-active")
    $(".btn-phone").removeClass("d-none")
})

$(".feedback-list li a").click(function() {
    $(".feedback-list li a").removeClass("active")
    $(this).addClass("active")
})

$(".calendar-actions .time-format li a").click(function() {
    $(".calendar-actions .time-format li a").removeClass("active")
    $(this).addClass("active")
})

$(".calendar-actions .time-schedule li a").click(function() {
    $(".calendar-actions .time-schedule li a").removeClass("active")
    $(this).addClass("active")
})

$(".calendar-actions .time-available li a").click(function() {
    $(".calendar-actions .time-available li a").removeClass("active")
    $(this).addClass("active")
})

$(".filter-btn-calendar").click(function() {
    $(".feedback-overlay").addClass("feedback-active")
    $(".wrapper__inner--alt").addClass("feedback-active")
    $(".btn-phone").addClass("d-none")
})